import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllIntent: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllIntent`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getIntentById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getIntentById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateCategoryForKB: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addCategoryForKB: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getFlowById: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getFlowById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateTsFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateTsFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addTsFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addTsFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getFlowByIntentId: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getFlowByIntentId`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addStep: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/addStep`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateStep: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateStep`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getActiveIntent: builder.query({
            query: () => ({
                url: 'knowledgeBase/getAllActiveIntent'
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        // KB 

        getAllCategoryForKB: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllCategories`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllFlowsbyCategory: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllFlowsbyCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllQuestions: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllQuestions`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        manageQuestions: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateQuesAns`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        deleteQuestion: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/deleteQuestion`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        deleteFlow: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/deleteFlow`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllQuestionsForDropdown: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/getAllQues`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        importKnowledgebase: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/import-kb`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateKnowledgebase: builder.mutation({
            query: (body) => ({
                url: `knowledgeBase/updateImportedKBData`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useGetAllIntentMutation, useGetIntentByIdMutation, useUpdateCategoryForKBMutation, useAddCategoryForKBMutation, useGetFlowByIdMutation,
    useUpdateTsFlowMutation, useAddTsFlowMutation, useGetFlowByIntentIdMutation, useAddStepMutation, useUpdateStepMutation, useGetActiveIntentQuery,
    useGetAllCategoryForKBMutation, useGetAllFlowsbyCategoryMutation, useGetAllQuestionsMutation, useManageQuestionsMutation, useDeleteQuestionMutation, useDeleteFlowMutation,
    useGetAllQuestionsForDropdownMutation, useImportKnowledgebaseMutation , useUpdateKnowledgebaseMutation
} = Api
